import DelegationHumanization from './DelegationHumanization'

export default DelegationHumanization
